import { Injectable } from '@angular/core';
import { HttpModule, Http, ConnectionBackend, RequestOptionsArgs, Request, Response, XHRBackend, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { AppSettings } from './app-settings';

@Injectable()
/**
 * Extensión personalizada de la clase HTTP
 * Permite la configuración de todas las peticiones
 * Captura los envíos y respuestas
 * */
export class HttpService extends Http {
    /** Las direcciones base deberían venir de la configuración del environment*/

    private authorization = '';

    constructor(
        backend: XHRBackend,
        options: RequestOptions,
        private router: Router
        //private userStore: SessionStoreService
    ) {
        super(backend, options);
        //this.subscribeToToken();
        
        //let token = localStorage.getItem('auth_token'); // your custom token getter function here
        //options.headers.set('Authorization', `Bearer ${token}`);
    }

    /**
     * Reescribe el método de la clase base, ejecutando acciones para cada petición
     * La peticiíón en curso puede llegar como una ruta o una clase request
     * Si viene sólo la cadena, debería traer las opciones aparte
     * */
    request(request: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        /*
        let token = localStorage.getItem('auth_token');
            if (typeof url === 'string') { // meaning we have to add the token to the options, not in url
            if (!options) {
                // let's make option object
                options = {headers: new Headers()};
            }
            options.headers.set('Authorization', `Bearer ${token}`);
            } else {
            // we have to add the token to the url object
            url.headers.set('Authorization', `Bearer ${token}`);
            }
            return super.request(url, options).catch(this.catchAuthError(this));
        */

        this.configureRequest(request, options);
        return this.interceptResponse(request, options);
    }

    private catchAuthError (self: HttpService) {
        // we have to pass HttpService's own instance here as `self`
        return (res: Response) => {
          console.log(res);
          if (res.status === 401 || res.status === 403) {
            // if not authenticated
            console.log(res);
          }
          return Observable.throw(res);
        };
      }

    private subscribeToToken() {
        // suponemos un servicio que nos avisa de la recepción de tokens
        /*this.userStore
            .getDataObservable()
            .subscribe((data: Session) => this.authorization = 'Bearer ' + data.token);*/
    }

    private configureRequest(request: string | Request, options: RequestOptionsArgs) {
        // Adapta la ruta y asigna cabeceras
        if (typeof request === 'string') {
            request = this.getProxyUrl(request);
            this.setHeaders(options);
        } else {
            request['url'] = this.getProxyUrl(request['url']);
            this.setHeaders(request);
        }
    }

    private interceptResponse(request: string | Request, options: RequestOptionsArgs): Observable<Response> {
        const observableRequest = super
            .request(request, options)
            .catch(this.onCatch());
            //.finally(this.onFinally());
        return observableRequest;
    }

    /**
     * Transforma la url para llamar a trave´s de un proxy 
     * Útil en caso de problemas con el CORS
     */
    private getProxyUrl(currentUrl) {
        if (!currentUrl.includes('/assets/')) {
            return AppSettings.URL + currentUrl;
        } else {
            return currentUrl;
        }
    }

    /**
     * Interceptor para componer las cabeceras en cada petición
     * */
    private setHeaders(objectToSetHeadersTo: Request | RequestOptionsArgs) {
        const headers = objectToSetHeadersTo.headers;
        headers.set('Accept', 'application/json, text/plain, */*');
        //headers.set('Authorization', this.authorization);
        headers.set('X-Requested-With', 'XMLHttpRequest');
        let tk = localStorage.getItem(AppSettings.TOKEN);
        if(tk)
            headers.set('AuthorizationTrilce', tk);
    }

    /**
     * Interceptor para captura genérica de errores http
     * */
    private onCatch() {
        return (res: Response) => {
            // Security errors
            if (res.status === 401 || res.status === 403) {
                alert("Su sesión ha caducado, por favor vuelva a ingresar");
                localStorage.removeItem(AppSettings.TOKEN);
                localStorage.removeItem(AppSettings.STORAGE_NAME);
                // redirigir al usuario para pedir credenciales
                this.router.navigate(['login']);
                location.reload();
            }

            return Observable.throw(res.json() || 'Server error');
        };
    }

    private onFinally() {
        return () => console.log('Fin');
    }
}


// WEBPACK FOOTER //
// C:/Users/egila/Downloads/temp/20260608_NuevoSAT/Trilce.Presentacion.Intranet.Profesores.NG5/src/app/support/services/http.service.ts